import { render, staticRenderFns } from "./memberCoursePackage.vue?vue&type=template&id=0e64c490&scoped=true&"
import script from "./memberCoursePackage.vue?vue&type=script&lang=js&"
export * from "./memberCoursePackage.vue?vue&type=script&lang=js&"
import style0 from "./memberCoursePackage.vue?vue&type=style&index=0&id=0e64c490&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e64c490",
  null
  
)

export default component.exports